export const smsOptInCheckboxVariantDefault = 'control';
